import{
    getStats,
    getMasters,
    getRecentJobs,
    getFailedJobs,
    getWorkload,
    sentBash
} from '../../api/queueMonitorApi'
import {Message} from "element-ui";

const state={
    stats:{},
    masters:{},
    failed:{},
    recent:{},
    workload:[],
    errors: {
        stats: null,
        masters: null,
        workload: null,
        recent: null,
        failed: null
    },
    shownErrors: {},
    isInitialLoad: true
}

const getters = {
    getStats: state => state.stats,
    getMasters: state => state.masters,
    getFailedJobs: state => state.failed,
    getRecentJobs: state => state.recent,
    getWorkload: state => state.workload,
    getStatsError: state => state.errors.stats,
    getMastersError: state => state.errors.masters,
    getWorkloadError: state => state.errors.workload,
    getRecentJobsError: state => state.errors.recent,
    getFailedJobsError: state => state.errors.failed,
    hasAnyError: state => Object.values(state.errors).some(error => error !== null)
}

const mutations = {
    SET_STATS: (state, payload) => {
        state.stats = payload
        state.errors.stats = null
    },
    SET_MASTERS: (state, payload) => {
        state.masters = payload
        state.errors.masters = null
    },
    SET_WORKLOAD: (state, payload) => {
        state.workload = payload
        state.errors.workload = null
    },
    SET_FAILED_JOBS: (state, payload) =>{
        state.failed = payload
        state.errors.failed = null
    },
    SET_RECENT_JOBS: (state, payload) =>{
        state.recent = payload
        state.errors.recent = null
    },
    SET_STATS_ERROR: (state, error) => {
        state.errors.stats = error
    },
    SET_MASTERS_ERROR: (state, error) => {
        state.errors.masters = error
    },
    SET_WORKLOAD_ERROR: (state, error) => {
        state.errors.workload = error
    },
    SET_FAILED_JOBS_ERROR: (state, error) => {
        state.errors.failed = error
    },
    SET_RECENT_JOBS_ERROR: (state, error) => {
        state.errors.recent = error
    },
    ADD_SHOWN_ERROR: (state, error) => {
        state.shownErrors[error] = true
    },
    SET_INITIAL_LOAD_COMPLETE: (state) => {
        state.isInitialLoad = false
    },
    RESET_INITIAL_LOAD: (state) => {
        state.isInitialLoad = true
    },
    RESET_SHOWN_ERRORS: (state) => {
        state.shownErrors = {}
    }
}
const actions = {
    sentBash: ({commit}, params) => {
        sentBash(params).then(resp => {
           if('output' in resp) {
               Message({
                   message: resp.output,
                   type: 'success',
                   duration: 5000,
                   showClose: true,
               })
           }
            if('error' in resp) {
                Message({
                    message: resp.error,
                    type: 'danger',
                    duration: 5000,
                    showClose: true,
                })
            }
        }).catch(err => console.log(err))
    },
    getStats: ({commit, state}, params) => {
        return getStats(params).then(resp => {
            commit('SET_STATS', resp)
            if (state.isInitialLoad) {
                commit('SET_INITIAL_LOAD_COMPLETE')
            }
            return resp
        }).catch(err => {
            const errorMessage = err.response?.data?.message || err.message || 'Network Error'
            commit('SET_STATS_ERROR', errorMessage)
            
            const errorKey = `stats:${errorMessage}`
            const shouldShowError = state.isInitialLoad && !state.shownErrors[errorKey]
            
            if (shouldShowError) {
                commit('ADD_SHOWN_ERROR', errorKey)
                Message({
                    message: `Queue Monitor: ${errorMessage}`,
                    type: 'error',
                    duration: 5000,
                    showClose: true
                })
            }
            
            if (state.isInitialLoad) {
                commit('SET_INITIAL_LOAD_COMPLETE')
            }
            
            return Promise.reject(err)
        })
    },
    getMasters: ({commit, state}, params) => {
        return getMasters(params).then(resp => {
            commit('SET_MASTERS', resp)
            if (state.isInitialLoad) {
                commit('SET_INITIAL_LOAD_COMPLETE')
            }
            return resp
        }).catch(err => {
            const errorMessage = err.response?.data?.message || err.message || 'Network Error'
            commit('SET_MASTERS_ERROR', errorMessage)
            
            const errorKey = `masters:${errorMessage}`
            const shouldShowError = state.isInitialLoad && !state.shownErrors[errorKey]
            
            if (shouldShowError) {
                commit('ADD_SHOWN_ERROR', errorKey)
                Message({
                    message: `Queue Monitor: ${errorMessage}`,
                    type: 'error',
                    duration: 5000,
                    showClose: true
                })
            }
            
            if (state.isInitialLoad) {
                commit('SET_INITIAL_LOAD_COMPLETE')
            }
            
            return Promise.reject(err)
        })
    },
    getFailedJobs: ({commit, state}, params) => {
        return getFailedJobs(params).then(resp => {
            commit('SET_FAILED_JOBS', resp)
            if (state.isInitialLoad) {
                commit('SET_INITIAL_LOAD_COMPLETE')
            }
            return resp
        }).catch(err => {
            const errorMessage = err.response?.data?.message || err.message || 'Network Error'
            commit('SET_FAILED_JOBS_ERROR', errorMessage)
            
            const errorKey = `failed:${errorMessage}`
            const shouldShowError = state.isInitialLoad && !state.shownErrors[errorKey]
            
            if (shouldShowError) {
                commit('ADD_SHOWN_ERROR', errorKey)
                Message({
                    message: `Queue Monitor: ${errorMessage}`,
                    type: 'error',
                    duration: 5000,
                    showClose: true
                })
            }
            
            if (state.isInitialLoad) {
                commit('SET_INITIAL_LOAD_COMPLETE')
            }
            
            return Promise.reject(err)
        })
    },
    getRecentJobs: ({commit, state}, params) => {
        return getRecentJobs(params).then(resp => {
            commit('SET_RECENT_JOBS', resp)
            if (state.isInitialLoad) {
                commit('SET_INITIAL_LOAD_COMPLETE')
            }
            return resp
        }).catch(err => {
            const errorMessage = err.response?.data?.message || err.message || 'Network Error'
            commit('SET_RECENT_JOBS_ERROR', errorMessage)
            
            const errorKey = `recent:${errorMessage}`
            const shouldShowError = state.isInitialLoad && !state.shownErrors[errorKey]
            
            if (shouldShowError) {
                commit('ADD_SHOWN_ERROR', errorKey)
                Message({
                    message: `Queue Monitor: ${errorMessage}`,
                    type: 'error',
                    duration: 5000,
                    showClose: true
                })
            }
            
            if (state.isInitialLoad) {
                commit('SET_INITIAL_LOAD_COMPLETE')
            }
            
            return Promise.reject(err)
        })
    },
    getWorkload: ({commit, state}, params) => {
        return getWorkload(params).then(resp => {
            commit('SET_WORKLOAD', resp)
            if (state.isInitialLoad) {
                commit('SET_INITIAL_LOAD_COMPLETE')
            }
            return resp
        }).catch(err => {
            const errorMessage = err.response?.data?.message || err.message || 'Network Error'
            commit('SET_WORKLOAD_ERROR', errorMessage)
            
            const errorKey = `workload:${errorMessage}`
            const shouldShowError = state.isInitialLoad && !state.shownErrors[errorKey]
            
            if (shouldShowError) {
                commit('ADD_SHOWN_ERROR', errorKey)
                Message({
                    message: `Queue Monitor: ${errorMessage}`,
                    type: 'error',
                    duration: 5000,
                    showClose: true
                })
            }
            
            if (state.isInitialLoad) {
                commit('SET_INITIAL_LOAD_COMPLETE')
            }
            
            return Promise.reject(err)
        })
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}